import { render, staticRenderFns } from "./proListDialog.vue?vue&type=template&id=804167f0&scoped=true&"
import script from "./proListDialog.vue?vue&type=script&lang=js&"
export * from "./proListDialog.vue?vue&type=script&lang=js&"
import style0 from "./proListDialog.vue?vue&type=style&index=0&id=804167f0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "804167f0",
  null
  
)

export default component.exports